import Vue from "vue";
import VueRouter from "vue-router";
import WelcomeText from "../pages/WelcomeText.vue";
import Menu from "../pages/Menu.vue";
import TableSelector from "../pages/TableSelector.vue";
import CartNew from "../pages/CartNew.vue";
import CartOld from "../pages/CartOld.vue";
import CartIndex from "../pages/CartIndex.vue";
import CartPickup from "../pages/CartPickup.vue";
import TableConfirm from "../pages/TableConfirm.vue";
import Redirect from "../pages/Redirect.vue";
import EnterPage from "../pages/EnterPage.vue";
import VersionPage from "../pages/VersionPage.vue";
import OrderCompleted from "../pages/OrderCompleted.vue";
import MyOrder from "../pages/MyOrder.vue";
import Payment from "../pages/Payment.vue";
import PaymentOrder from "../pages/PaymentOrder.vue";
import PaymentOrderIndex from "../pages/PaymentOrderIndex.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/version",
    name: "Version",
    component: VersionPage,
  },
  {
    path: "/enter",
    name: "Enter",
    component: EnterPage,
  },
  {
    path: "/",
    name: "Welcome",
    component: WelcomeText,
  },
  {
    path: "/table",
    name: "TableSelector",
    component: TableSelector,
  },
  {
    path: "/table/:tableId",
    name: "TableConfirm",
    component: TableConfirm,
  },
  {
    path: "/menu",
    name: "Menu",
    component: Menu,
  },
  {
    path: "/menu/:category_id",
    name: "MenuCategory",
    component: Menu,
  },
  {
    path: "/cart-old",
    name: "cart-old",
    component: CartOld,
  },
  {
    path: "/cart",
    name: "cart",
    component: CartIndex,
  },
  {
    path: "/cart-pickup",
    name: "cart-pickup",
    component: CartPickup,
  },
  {
    path: "/payment",
    name: "payment",
    component: PaymentOrderIndex,
  },
  {
    path: "/payment-order-old",
    name: "paymentOrderOld",
    component: PaymentOrder,
  },
  {
    path: "/payment-order",
    name: "paymentOrderIndex",
    component: PaymentOrderIndex,
  },
  {
    path: "/redirect",
    name: "redirect",
    component: Redirect,
  },
  {
    path: "/session/:sessionId",
    name: "session",
    component: Redirect,
  },
  {
    path: "/order-completed",
    name: "OrderCompleted",
    component: OrderCompleted,
  },
  {
    path: "/my-order",
    name: "MyOrder",
    component: MyOrder,
  },
];
const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
